
<ng-template  #gUsers>    
     <div class="modal-header headerBackground">
        <h6 class="modal-title">Users</h6>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12"><p><strong>Users List</strong></p></div>
            <div class="col-md-12">
                <table class="table table-sm">
                    <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col"><i class="fas fa-user"></i>Users</th>
                          
                        </tr>
                      </thead>
                      <tbody>
                      <tr [id]="'gr-'+guser.ID"  *ngFor="let guser of globalUsers">
                          
                          <td><input #cs type="checkbox" [id]="'g-'+guser.ID" [checked]="guser.IsAllowed" (change)="pickUser(guser,cs.checked)"/>
                          </td>
                          <td>{{guser.Name}}</td>
                      </tr>
                      </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer ">
        <button class="btn btn-secondary" (click)="updateRecordUserList();gUserModalRef.hide();" >Add Selected Users</button>
        <button class="btn btn-secondary"  (click)="gUserModalRef.hide();">Cancel</button>
    </div>
    
</ng-template>
<ng-template #accessRightEditorTemplate>
    <div class="modal-header headerBackground">
        <h6 class="modal-title pull-left ">Access Controller</h6>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <p><strong>Record : <span class="permitHighlight">{{activeRecord.Name}} </span> </strong></p>
            </div>

            <div class="col-md-11">
                <p><strong>User Entries <i class="fa fa-users" aria-hidden="true"></i> :
                </strong></p>
            </div>
            <div class="col-md-1">
                <button class="btn btn-sm " title="Add User" (click)="addUsers()">
                    <i id="button_AddUser"></i></button> 
            </div>

            <div class="col-md-12 table-responsive">
                    <table class="table table-sm">
                        <thead>
                          <tr>
                           
                            <th scope="col">User</th>
                            <th scope="col">Type</th>
                            <th scope="col">Access</th>
                          </tr>
                        </thead>
                        <tbody>
                            
                        <tr [id]="'i-'+user.ID" (click)="switchChannel(user);updateControl(user,true)" *ngFor="let user of activeRecord.AccessUsers">
                            
                            <td>{{user.Name}}</td>
                            <td>{{user.Type}}</td>
                            
                            <td ><span *ngFor="let r of user.AccessRights"><p *ngIf="r.IsAllowed == true" >{{r.Name}}</p></span></td>
                        </tr>
                        </tbody>
                      </table>
                </div>
            <div class="col-md-12">
                <!--<tabset>
                    <tab heading="Permission">-->
                        <div *ngIf="records.length == 0" class="row">
                            <div class="col-md-12 balanceColumn">
                                <p><strong> No record exists to assign Permission </strong></p>
                            </div>
                        </div>
                        <div  *ngIf="records.length>0" class="row">
                            <div class="col-md-6 balanceColumn">
                                <p id="rightmatrix" ><strong>Permission for : <span class="permitHighlight" *ngIf="activeAssignedUser != null ">{{activeAssignedUser.Name}}</span></strong></p>
                                <fieldset disabled id="rights-list" class="listMultiSelectContainer" style="height: 9em">
                                    <ul  class="list-group">
                                        <li class="list-group-item" style="height: 25px; padding: 0px 10px; border:0px;">
                                           <table *ngIf="activeAssignedUser != null " >

                                               <tr *ngFor="let right of activeAssignedUser.AccessRights">
                                                   <td width="50%">
                                                      {{right.Name}} 
                                                   </td>
                                                   <td width="50%">
                                                    <div class="custom-control custom-switch">
                                                        <input #cs type="checkbox" class="custom-control-input " [id]="activeAssignedUser.ID+'-'+right.ID" [checked] = "right.IsAllowed" (change)="updateControl(right,cs.checked)">
                                                        <label class="custom-control-label" [for]="activeAssignedUser.ID+'-'+right.ID"></label>
                                                    </div>
                                                   </td>
                                               </tr>
                                           </table>
                                           <table *ngIf="activeAssignedUser == null" >
                                                 <tr *ngFor="let right of rights">
                                                    <td width="50%">
                                                       {{right.Name}} 
                                                    </td>
                                                    <td width="50%">
                                                     <div class="custom-control custom-switch">
                                                         <input #cs type="checkbox" class="custom-control-input " [id]="right.ID" [checked] = "right.IsAllowed" (change)="updateControl(right,cs.checked)">
                                                         <label class="custom-control-label" [for]="right.ID"></label>
                                                     </div>
                                                    </td>
                                                </tr>
                                           </table>
                                        </li> 
                                    </ul>
                                </fieldset>
                            </div>
                        </div>
                    <!--</tab>
                </tabset>-->
            </div>
        </div>
    </div>
    <div class="modal-footer ">
        <button class="btn btn-secondary"  (click)="accessModalRef.hide();">Save</button>
        <button class="btn btn-secondary"  (click)="accessModalRef.hide();">Cancel</button>
    </div>
</ng-template>